/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { space } from 'style/config';
import { Box, Text, Grid } from 'components/ui';
import BasketBreakdownSummary from 'components/BasketBreakdownSummary/BasketBreakdownSummary';
import localeUtils from 'utils/LanguageLocale';
import StandardAndSddOrderSummaryEN from 'components/RichProfile/MyAccount/OrderDetail/StandardAndSddOrderSummary/locales/StandardAndSddOrderSummary_en_US';
import StandardAndSddOrderSummaryFR from 'components/RichProfile/MyAccount/OrderDetail/StandardAndSddOrderSummary/locales/StandardAndSddOrderSummary_fr_CA';

const { getLocalisedDataFromResource } = localeUtils;
const getText = getLocalisedDataFromResource(StandardAndSddOrderSummaryEN, StandardAndSddOrderSummaryFR);

const StandardAndSddOrderSummary = ({ itemsLink = false, ...props }) => {
    return (
        <Grid
            alignItems='flex-start'
            columns={[null, null, 2]}
            gap={5}
        >
            <Box
                borderRadius={2}
                padding={3}
                backgroundColor='nearWhite'
                lineHeight='tight'
            >
                <Text
                    is='h3'
                    fontSize='md'
                    fontWeight={'bold'}
                    children={getText('orderSummary')}
                    marginBottom={space[1]}
                />
                <BasketBreakdownSummary
                    {...props}
                    itemsLink={itemsLink}
                />
            </Box>
        </Grid>
    );
};

StandardAndSddOrderSummary.propTypes = {
    itemsLink: PropTypes.bool
};

export default wrapFunctionalComponent(StandardAndSddOrderSummary, 'StandardAndSddOrderSummary');
